import defaultPlaylistOrange from '@/public/images/default_playlist_orange.svg';
import defaultPlaylistPeach from '@/public/images/default_playlist_peach.svg';
import defaultPlaylistPink from '@/public/images/default_playlist_pink.svg';
import defaultPlaylistPurple from '@/public/images/default_playlist_purple.svg';
import defaultPlaylistYellow from '@/public/images/default_playlist_yellow.svg';

import type { StaticImageData } from 'next/image';

export const defaultPlaylistImages: {
  image: StaticImageData;
  publicPath: string;
}[] = [
  {
    image: defaultPlaylistOrange,
    publicPath: '/images/default_playlist_orange.svg',
  },
  {
    image: defaultPlaylistYellow,
    publicPath: '/images/default_playlist_yellow.svg',
  },
  {
    image: defaultPlaylistPurple,
    publicPath: '/images/default_playlist_purple.svg',
  },
  {
    image: defaultPlaylistPink,
    publicPath: '/images/default_playlist_pink.svg',
  },
  {
    image: defaultPlaylistPeach,
    publicPath: '/images/default_playlist_peach.svg',
  },
];

export const getRandomDefaultImageImport = (): StaticImageData =>
  defaultPlaylistImages[
    Math.floor(Math.random() * defaultPlaylistImages.length)
  ].image;
